<template>
  <div class="md-layout">
    <div class="md-layout-item md-xsmall-size-100 md-size-30">
      <md-card>
        <md-card-content>
          <strategies-list
            ref="list"
            :hotels="hotels"
            :endpoints="endpoints"
            :new-item-name="newItemName"
            :itemType="itemType"
            v-on:toggleModal="openModal"
            v-on:select="loadItem"
            v-on:change="changeList"
          ></strategies-list>
        </md-card-content>
        <md-card-actions>
          <md-button @click="$refs.list.add()">New</md-button>
        </md-card-actions>
      </md-card>
      <ul v-if="showLegend" class="legend">
        <li class="selected">Selected</li>
        <li class="active">Active</li>
        <li class="innactive">Innactive</li>
        <li v-if="withOverriden" class="overriden">Overriden</li>
      </ul>
    </div>
    <div v-if="selectedItem" class="md-layout-item md-xsmall-size-100 md-size-70">
      <slot name="itemCard" v-bind:value="selectedItem">
        <strategy-item :endpoints="endpoints" v-bind:item="selectedItem" v-on:saved="saved" v-on:deleted="deleteSelected">
          <template v-slot:extraHeaderFields="{ value }">
            <slot name="extraHeaderFields" v-bind:value="value" />
          </template>

          <template v-slot:default="{ value }">
            <!-- Specific rules up here -->
            <slot name="default" v-bind:value="value" />
            <!-- ---------------------- -->
          </template>
        </strategy-item>
      </slot>
    </div>
    <advanced-duplication-modal :hotels="hotels" ref="advancedDuplicationModal" v-on:duplicateItem="duplicateItem" />
  </div>
</template>

<script>
import Api from '@/openapi/src/api/HotelApi.js'
import AdvancedDuplicationModal from './AdvancedDuplicationModal.vue'
import StrategiesList from './StrategiesList.vue'
import StrategyItem from './StrategyItem.vue'

export default {
  name: 'AbstractStrategyPage',
  components: {
    StrategiesList,
    StrategyItem,
    AdvancedDuplicationModal,
  },
  data() {
    return {
      selectedItem: null,
      hotels: [],
      selectedItemIdx: -1,
    }
  },
  props: {
    endpoints: Object,
    newItemName: {
      type: String,
      default: 'New Strategy',
    },
    itemType: String,
    withOverriden: Boolean,
    showLegend: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    duplicateItem(selectedHotelIds) {
      this.$refs.list.duplicateToOtherHotels(selectedHotelIds, this.selectedItemIdx)
      this.$refs.advancedDuplicationModal.closeModal()
    },
    openModal(index) {
      this.selectedItemIdx = index
      this.$refs.advancedDuplicationModal.openModal()
    },
    retrieveHotels() {
      new Api().getHotels((error, data) => {
        this.hotels = data.filter((hotel) => hotel.id != this.$root.hotelId)
      })
    },
    loadItem(item) {
      this.selectedItem = null
      var $vm = this
      setTimeout(function() {
        $vm.selectedItem = item
        $vm.$emit('item-selected', item)
      }, 10)
    },
    saved(newData) {
      this.$root.$emit('saved')
      this.$refs.list.update(newData)
    },
    deleteSelected() {
      this.$refs.list.deleteSelected()
    },
    unselectItem() {
      this.$refs.list.select(false)
    },
    changeList(data) {
      this.$emit('change', data)
    },
    retrieveStrategies() {
      this.$refs.list.retrieveStrategies()
    },
  },

  created() {
    this.retrieveHotels()
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/md/_variables.scss';

ul.legend {
  list-style: none;
  padding: 0;
  display: flex;
  font-size: 13px;
  justify-content: space-around;

  li {
    padding: 0.5rem;
    background: white;
    color: rgba(0, 0, 0, 0.87);
    font-weight: 400;
  }

  .selected {
    background: $brand-primary;
    color: white;
  }

  .innactive {
    color: rgba(0, 0, 0, 0.26);
  }

  .overriden {
    background: #eee4e1;
  }
}
</style>
